import {Component, Inject, Injector, PLATFORM_ID} from '@angular/core';
import {Params, RouterOutlet} from '@angular/router';
import {CommonModuleModule} from "./common-module/common-module.module";
import {Config} from "../common/config";
import {BaseComponent} from "./base.component";
import {DataResponse} from "../network/service/data.response";
import {SnackBarUtil} from "../util/snack.bar.util";
import {DashboardModule} from "./dashboard/dashboard.module";
import {RouteUtil} from "../util/route.util";
import {ClientModule} from "./client/client.module";
import {ListResponse} from "../network/service/list.response";
import {RequestType} from "../enums/request.type";
import {UserType} from "../enums/user.type";
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import {isPlatformBrowser} from "@angular/common";
import {DocumentUtil} from '../util/document.util';
import {SessionStorageUtil} from '../util/session.storage.util';
import {strings} from '../../value/strings';
import {SwUpdate} from '@angular/service-worker';
import {NotificationService} from '../util/service/notification.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModuleModule, DashboardModule, ClientModule],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent extends BaseComponent {
  updateAvailable: boolean = false;
  protected readonly Config = Config;
  protected readonly RouteUtil = RouteUtil;

  constructor(injector: Injector, swUpdate: SwUpdate, notificationService: NotificationService, @Inject(PLATFORM_ID) private platformId: string) {
    super(injector);
    if (isPlatformBrowser(platformId) && this.authenticationService.hasAccount()) {
      notificationService.subscribeToNotifications();
    }
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (params['SpaceId'] && params['SpaceId'] !== '') {
        SessionStorageUtil.saveInt(strings.customer_space_id, params['SpaceId']);
      }
    });
    if (swUpdate.isEnabled) {
      swUpdate.versionUpdates.subscribe(event => {
        if (event.type === 'VERSION_READY') {
          this.updateAvailable = true;
        }
      });
    }
    Config.platformId = platformId;
  }

  override loadOnline() {
    super.loadOnline();
    this.serviceApi.getDomainDetail().subscribe((res: DataResponse<any>) => {
      if (res.success) {
        Config.domain = res.data;
        if (Config.domain.Details.ContainerId) {
          DocumentUtil.updateElementBody(this.renderer, 'head', 'google-tag-head', `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'}); var f=d.getElementsByTagName(s)[0], j=d.createElement(s), dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${Config.domain.Details.ContainerId}');`);
          DocumentUtil.updateElementBody(this.renderer, 'body', 'google-tag-body', `<iframe src="https://www.googletagmanager.com/ns.html?id=${Config.domain.Details.ContainerId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`);
        }
        if (Config.domain.Title) {
          this.titleService.setTitle(Config.domain.Title);
          DocumentUtil.updateHeadAttribute(this.renderer, 'apple-title', 'content', Config.domain.Title);
        }
        if (Config.domain.Details.PrimaryColor) {
          DocumentUtil.updateHeadAttribute(this.renderer, 'theme-color', 'content', Config.domain.Details.PrimaryColor);
        }
        if (Config.domain.Details.ManifestFileId) {
          DocumentUtil.updateHeadAttribute(this.renderer, 'manifest', 'href', this.formatImage('', Config.domain.Details.ManifestFileId));
        }
        if (Config.domain.Details.Favicon) {
          DocumentUtil.updateHeadAttribute(this.renderer, 'favicon', 'href', this.formatImage('', Config.domain.Details.Favicon));
        }
        if (Config.domain.Details.AppleFavicon) {
          DocumentUtil.updateHeadAttribute(this.renderer, 'apple-favicon', 'href', this.formatImage('', Config.domain.Details.AppleFavicon));
        }
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
    if (this.authenticationService.hasAccount()) {
      this.serviceApi.getUserInformation().subscribe((res: DataResponse<any>) => {
        if (res.success) {
          Config.userInformation = res.data;
          Config.selectedBusinessId = Config.userInformation.BusinessId;
          if (Config.userInformation.UserType === UserType.STAFF) {
            this.serviceApi.getMyPermissions(undefined, undefined, undefined, RequestType.ALL).subscribe((res: ListResponse<any>) => {
              if (res.success) {
                Config.permissions = res.data;
              }
            });
            this.serviceApi.getBusinesses(undefined, undefined, undefined, RequestType.ALL, {
              Order: {
                Field: 'BusinessId',
                Type: 'ASC'
              }
            }).subscribe((res: ListResponse<any>) => {
              if (res.success) {
                Config.businesses = res.data;
              }
            });
          }
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
        }
      });
    }
  }

  override ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      FingerprintJS.load().then((onFullFilled: any) => {
        onFullFilled.get().then((onFullFilled: any) => {
          Config.visitorId = onFullFilled.visitorId;
        });
      });
      window.addEventListener('storage', (event: any) => {
        if (event.key === null) {
          window.location.href = '/';
        }
      });
    }
    super.ngOnInit();
  }

  reload() {
    window.location.reload();
  }
}
